import * as React from "react"
import * as _ from "lodash"
import IFoodCategory from "../../models/IFoodCategory"
import {FoodGroup, FoodGroupsMapping} from "../../utils/AppConstants";
import IFoodGroup from "../../models/IFoodGroup";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import SingleFoodGroupItem from "../SingleFoodGroupItem";
import AppUtils from "../../utils/AppUtils";

/**
 * Created by aditya on 28/06/18.
 */

export interface FoodGroupItemEditorProps {
    consultationType?: string,
    item: IFoodGroup[];
    onDataChange: (update: any) => any,
    staticFoodGroups: IFoodCategory[]
}

class FoodGroupItemEditor extends React.Component<FoodGroupItemEditorProps> {
    constructor(props: FoodGroupItemEditorProps) {
        super(props)
    }

    onDistributionChange = (evt: any, itemId: string) => {
        let value = evt.target.value;
        if (!isNaN(parseInt(value))) {
            let currentDistribution = !_.isEmpty(this.props.item) ? this.props.item : [];
            let item = currentDistribution.filter(item => item.foodgroups[0] === itemId);
            if (item.length) {
                let updatedItem = item[0];
                updatedItem.foodgroups = [itemId];
                updatedItem.contribution = parseInt(value);

                let index = currentDistribution.map(item => item.foodgroups[0]).indexOf(itemId);
                currentDistribution.splice(index, 1);
                currentDistribution.push(updatedItem);
            } else {
                let updatedItem = ModelFactory.createNewCalorieBreakup();
                updatedItem.foodgroups = [itemId];
                updatedItem.contribution = parseInt(value);

                currentDistribution.push(updatedItem);
            }
            this.props.onDataChange(currentDistribution);
        } else if (value === "") {
            let currentDistribution = !_.isEmpty(this.props.item) ? this.props.item : [];
            let item = currentDistribution.filter(item => item.foodgroups[0] === itemId);
            if (item.length) {
                let updatedItem = item[0];
                updatedItem.foodgroups = [itemId];
                updatedItem.contribution = parseInt(value);

                let index = currentDistribution.map(item => item.foodgroups[0]).indexOf(itemId);
                currentDistribution.splice(index, 1);
            }
            this.props.onDataChange(currentDistribution);
        }
    }

    onDistributionValueChange = (value: number, index: number) => {
        let items = [ ...this.props.item ];
        let foodGroupItem = items[index];
        foodGroupItem.contribution = value;
        items[index] = foodGroupItem;
        this.props.onDataChange(items);
    }

    onThemeLabelChange = (label: string, index: number) => {
        let foodGroups = [ ...this.props.item ];
        let requiredFoodGroup = foodGroups[index];
        requiredFoodGroup.foodgroups = FoodGroupsMapping[label];
        foodGroups[index] = requiredFoodGroup;
        this.props.onDataChange(foodGroups);
    }

    calculateTotalContribution = () => {
        let totalDistribution = 0;
        _.map(this.props.item, (item) => {
            let contribution = !isNaN(item.contribution) && AppUtils.isDefined(item.contribution) && item.contribution.toString() !== "" ? parseInt(item.contribution.toString()) : 0;
            totalDistribution += contribution
        })
        return totalDistribution;
    }

    generateStaticFoodCategories = () => {
        let foodCategories: IStaticDataValue[] = [];
        _.map(FoodGroup, (value, key) => {
            foodCategories.push({
                displayValue: value,
                internalValue: key
            })
        })
        return foodCategories;
    }

    addFoodGroup = () => {
        let foodGroups = [ ...this.props.item ];
        foodGroups.push({ foodgroups: [""], contribution: "" as any });
        this.props.onDataChange(foodGroups);
    }
    onFoodGroupRemove = (index: number) => {
        let foodGroups = [ ...this.props.item ];
        foodGroups.splice(index, 1);
        this.props.onDataChange(foodGroups);
    }
    render() {
        let selectedFoodGroups = this.props.item;
        let staticFoodCategories = FoodGroup;
        let totalDistribution = this.calculateTotalContribution();
        return (
            <div className="food-groups-item-editor" >
                <div className={"theme-label"}>
                    Theme
                    <div className={`${this.calculateTotalContribution() > 100 ? "red-highlight" : ""} brandon-bold`}>{totalDistribution}/100%</div>
                    {
                        this.calculateTotalContribution() > 100 &&
                            <span className={"error-container"}>
                                <span className="glyphicon glyphicon-remove-circle" />
                                Total cannot exceed 100%
                            </span>
                    }
                </div>
                <div className={"food-categories-container"}>
                    {
                        _.map(selectedFoodGroups, (item, key) => {
                            return <SingleFoodGroupItem callbackMeta={key} staticFoodGroups={this.generateStaticFoodCategories()}
                                                        selectedFoodGroups={item.foodgroups} themeValue={item.contribution}
                                                        onThemeLabelSelect={this.onThemeLabelChange} onCategoryValueChange={this.onDistributionValueChange}
                                                        onRemove={this.onFoodGroupRemove} />
                        })
                    }
                    <span className={"add-row-label-container"}>
                        <input type="button" value="+ Add" onClick={this.addFoodGroup} />
                    </span>
                </div>

            </div>
        )
    }
}

export default FoodGroupItemEditor;